import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  storageKey = 'jwt';

  constructor(private router: Router) {}

  setToken(token: string) {
    localStorage.setItem(this.storageKey, token);
  }

  setUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): any {
    const user = localStorage.getItem('user') || '';
    return JSON.parse(user);
  }

  setUserRole(role: string) {
    localStorage.setItem('userrole', role);
  }
  getUserRole() {
    return localStorage.getItem('userrole');
  }

  getToken() {
    return localStorage.getItem(this.storageKey);
  }

  isLoggedIn() {
    return this.getToken() !== null;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
